(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bco-weihnachtsbox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Einblenden beim Scrollen ---------- */
    function initReveal(root) {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var items = root.querySelectorAll('[data-bco-wb-reveal]');
      root.classList.add('bco-wb--animate');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    }

    /* ---------- Schneefall ---------- */
    var STORE_KEY = 'bco-wb-snow';
    var LEVELS = { light: [24000, 80], medium: [12500, 150], heavy: [7500, 240] };
    var RADII = [1.3, 1.9, 2.6, 3.4, 4.4, 6.2];
    var snow = null;

    function readPref() { try { return window.localStorage.getItem(STORE_KEY); } catch (e) { return null; } }
    function writePref(v) { try { window.localStorage.setItem(STORE_KEY, v); } catch (e) {} }

    function destroySnow() {
      if (!snow) return;
      snow.destroy();
      snow = null;
    }

    function createSnow(root) {
      destroySnow();
      var level = root.getAttribute('data-bco-wb-snow');
      if (!level || level === 'off' || !LEVELS[level]) return;
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext && canvas.getContext('2d');
      if (!ctx) return;
      canvas.className = 'bco-wb-snow';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);

      var html = document.documentElement;
      var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      function computeWanted() {
        if (html.getAttribute('data-a11y-motion') === 'reduce') return false;
        var pref = readPref();
        return pref ? pref === 'on' : !(mq && mq.matches);
      }
      var wanted = computeWanted();
      var inView = true;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var areaPer = LEVELS[level][0], cap = LEVELS[level][1];
      var W = 0, H = 0, flakes = [], raf = 0, last = 0, t = 0, lastScroll = window.pageYOffset || 0;

      var sprites = RADII.map(function (r) {
        var pad = 4, half = r + pad, size = Math.ceil(half * 2 * dpr);
        var c = document.createElement('canvas');
        c.width = c.height = size;
        var g = c.getContext('2d');
        g.scale(dpr, dpr);
        g.shadowColor = 'rgba(59,56,53,.32)';
        g.shadowBlur = 2.5;
        g.shadowOffsetY = 0.6;
        var grad = g.createRadialGradient(half, half, 0, half, half, r);
        grad.addColorStop(0, 'rgba(255,255,255,1)');
        grad.addColorStop(0.62, 'rgba(255,255,255,.94)');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = grad;
        g.beginPath();
        g.arc(half, half, r, 0, Math.PI * 2);
        g.fill();
        return { img: c, half: half };
      });

      function makeFlake(atTop) {
        var z = Math.pow(Math.random(), 1.6);
        var idx = Math.min(RADII.length - 1, Math.floor(z * (RADII.length - 0.4)));
        if (z > 0.93) idx = RADII.length - 1;
        return {
          x: Math.random() * W,
          y: atTop ? -10 - Math.random() * 40 : Math.random() * H,
          z: z,
          s: sprites[idx],
          vy: 16 + z * 52,
          amp: 6 + z * 22,
          freq: 0.25 + Math.random() * 0.6,
          ph: Math.random() * Math.PI * 2,
          a: 0.5 + z * 0.5
        };
      }

      function resize() {
        var oldW = W, oldH = H;
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (oldW && oldW !== W) {
          for (var i = 0; i < flakes.length; i++) { flakes[i].x *= W / oldW; flakes[i].y *= H / oldH; }
        }
        if (!oldW || oldW !== W) {
          var target = Math.max(18, Math.min(cap, Math.round((W * H) / areaPer)));
          while (flakes.length < target) flakes.push(makeFlake(false));
          if (flakes.length > target) flakes.length = target;
        }
      }

      function frame(now) {
        var dt = Math.min(0.05, (now - last) / 1000 || 0);
        last = now;
        t += dt;
        var sy = window.pageYOffset || 0, ds = sy - lastScroll;
        lastScroll = sy;
        if (Math.abs(ds) > H * 0.6) ds = 0; /* Sprung (Anker-Link): kein Parallax, sonst leert sich der Himmel */
        var wind = Math.sin(t * 0.13) * 12 + Math.sin(t * 0.047 + 1.3) * 9;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.y += f.vy * dt - ds * (0.12 + f.z * 0.4);
          f.x += wind * (0.35 + f.z) * dt;
          if (f.y > H + 12) { flakes[i] = f = makeFlake(true); }
          else if (f.y < -60) { f.y = H + 10; }
          if (f.x < -20) f.x += W + 40; else if (f.x > W + 20) f.x -= W + 40;
          var dx = f.x + Math.sin(t * f.freq + f.ph) * f.amp;
          ctx.globalAlpha = f.a;
          ctx.drawImage(f.s.img, dx - f.s.half, f.y - f.s.half, f.s.half * 2, f.s.half * 2);
        }
        ctx.globalAlpha = 1;
        raf = window.requestAnimationFrame(frame);
      }

      function start() {
        if (raf || !wanted || !inView) return;
        canvas.classList.add('is-on');
        last = performance.now();
        lastScroll = window.pageYOffset || 0;
        raf = window.requestAnimationFrame(frame);
      }
      function stop(clear) {
        if (raf) window.cancelAnimationFrame(raf);
        raf = 0;
        canvas.classList.remove('is-on');
        if (clear) window.setTimeout(function () { if (!raf) ctx.clearRect(0, 0, W, H); }, 1300);
      }

      var toggle = null;
      function syncToggle() {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', wanted ? 'true' : 'false');
        toggle.setAttribute('title', wanted ? 'Schneefall pausieren' : 'Schneefall starten');
      }
      if (root.getAttribute('data-bco-wb-snow-toggle') !== 'false') {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bco-wb-snow-toggle';
        toggle.setAttribute('aria-label', 'Schneefall');
        toggle.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7"/><path d="M9.5 3.5L12 6l2.5-2.5M9.5 20.5L12 18l2.5 2.5M3.6 10.4l3.4-.9-.9-3.4M20.4 13.6l-3.4.9.9 3.4M3.6 13.6l3.4.9-.9 3.4M20.4 10.4l-3.4-.9.9-3.4"/></g></svg><span class="bco-wb-snow-toggle__off" aria-hidden="true"></span>';
        toggle.addEventListener('click', function () {
          wanted = !wanted;
          writePref(wanted ? 'on' : 'off');
          syncToggle();
          if (wanted) start(); else stop(true);
        });
        document.body.appendChild(toggle);
        syncToggle();
      }

      function onMotionPref() {
        wanted = computeWanted();
        syncToggle();
        if (wanted) start(); else stop(true);
      }
      var mo = window.MutationObserver ? new MutationObserver(onMotionPref) : null;
      if (mo) mo.observe(html, { attributes: true, attributeFilter: ['data-a11y-motion'] });
      if (mq) { if (mq.addEventListener) mq.addEventListener('change', onMotionPref); else if (mq.addListener) mq.addListener(onMotionPref); }

      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          if (inView) start(); else stop(true);
        });
        io.observe(root);
      }
      window.addEventListener('resize', resize);
      resize();
      start();

      return {
        root: root,
        destroy: function () {
          stop(false);
          window.removeEventListener('resize', resize);
          if (io) io.disconnect();
          if (mo) mo.disconnect();
          if (mq) { if (mq.removeEventListener) mq.removeEventListener('change', onMotionPref); else if (mq.removeListener) mq.removeListener(onMotionPref); }
          if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
          if (toggle && toggle.parentNode) toggle.parentNode.removeChild(toggle);
        }
      };
    }

    /* ---------- Danke-Popup ---------- */
    function initDialog(root) {
      var dlg = root.querySelector('[data-bco-wb-dialog]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var formId = dlg.getAttribute('data-form-id');
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
      /* Shopify leitet nach dem Absenden auf ?contact_posted=true#<Formular-ID> zurück */
      var viaUrl = !!params && params.get('contact_posted') === 'true' && window.location.hash === '#' + formId;
      function close() { if (dlg.open) dlg.close(); }
      function outside(e) {
        var r = dlg.getBoundingClientRect();
        return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
      }
      var downOutside = false;
      dlg.addEventListener('pointerdown', function (e) { downOutside = e.target === dlg && outside(e); });
      dlg.addEventListener('click', function (e) {
        if (downOutside && e.target === dlg && outside(e)) close();
        downOutside = false;
      });
      Array.prototype.forEach.call(dlg.querySelectorAll('[data-bco-wb-dialog-close]'), function (b) {
        b.addEventListener('click', close);
      });
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('bco-wb-modal-open');
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete('contact_posted');
          window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
        } catch (e) {}
        var ok = root.querySelector('.bco-wb__form-ok');
        if (ok && ok.focus) ok.focus({ preventScroll: true });
      });
      if ((dlg.hasAttribute('data-open-on-load') || viaUrl) && !(window.Shopify && window.Shopify.designMode)) {
        document.documentElement.classList.add('bco-wb-modal-open');
        dlg.showModal();
        /* Der Browser verarbeitet den Anker (#Formular) erst danach und nimmt dabei den Fokus weg */
        var first = dlg.querySelector('.bco-wb__modal-x') || dlg.querySelector('button');
        var focusInside = function () { if (dlg.open && first && !dlg.contains(document.activeElement)) first.focus({ preventScroll: true }); };
        window.requestAnimationFrame(function () { window.setTimeout(focusInside, 0); });
        window.addEventListener('load', focusInside, { once: true });
      }
    }

    /* ---------- Rückmeldung beim Absenden ----------
       Kein preventDefault: Shopifys Spam-Schutz (hCaptcha) übernimmt das eigentliche Absenden. */
    function initSending(root) {
      var form = root.querySelector('.bco-wb__form');
      var btn = form && form.querySelector('button[type="submit"]');
      if (!btn) return;
      var original = btn.innerHTML, timer = 0;
      var sendErr = form.querySelector('.bco-wb__form-err--send');
      function bound() { return form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound'); }
      function reset() { btn.classList.remove('is-sending'); btn.removeAttribute('aria-disabled'); btn.innerHTML = original; }
      function fail() { reset(); if (sendErr) { sendErr.hidden = false; sendErr.setAttribute('tabindex', '-1'); sendErr.focus({ preventScroll: false }); } }
      form.addEventListener('submit', function (e) {
        if (form.checkValidity && !form.checkValidity()) return;
        if (sendErr) sendErr.hidden = true;
        btn.classList.add('is-sending');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Wird gesendet …';
        window.clearTimeout(timer);
        timer = window.setTimeout(reset, 8000); /* falls ein Spam-Schutz-Fenster abgebrochen wird */
        window.setTimeout(function () {
          /* Ohne Abbruch läuft das normale Absenden; ist der Spam-Schutz gebunden, übernimmt er. */
          if (!e.defaultPrevented || bound()) return;
          /* Spam-Schutz noch nicht bereit (oder blockiert): kurz warten, dann erneut absenden */
          var t0 = Date.now();
          (function wait() {
            if (bound()) {
              window.clearTimeout(timer); reset();
              if (form.requestSubmit) form.requestSubmit(); else btn.click();
              return;
            }
            if (Date.now() - t0 > 10000) { window.clearTimeout(timer); fail(); return; }
            window.setTimeout(wait, 250);
          })();
        }, 0);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
    }

    function init(root) {
      if (!root || root.getAttribute('data-bco-wb-ready')) return;
      root.setAttribute('data-bco-wb-ready', '1');
      initReveal(root);
      initDialog(root);
      initSending(root);
      snow = createSnow(root) || null;
    }
    function initAll() {
      document.querySelectorAll('.bco-wb').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.bco-wb');
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (snow && event.target.contains(snow.root)) destroySnow();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
